import type React from 'react'

export interface ToggleProps {
  checked: boolean
  onChange: (v: boolean) => void
  label: string
  disabled?: boolean
  title?: string
  onClick?: React.MouseEventHandler<HTMLLabelElement>
}

export function Toggle({ checked, onChange, label, disabled, title, onClick }: ToggleProps) {
  return (
    <label
      className="toggle"
      title={title}
      style={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }}
      onClick={onClick}
    >
      <input
        type="checkbox"
        role="switch"
        checked={checked}
        disabled={disabled}
        aria-label={label}
        aria-checked={checked}
        aria-disabled={disabled || undefined}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="toggle-track" />
    </label>
  )
}
